import { useCallback, useMemo, useState } from 'react';
import type { ReportParameter } from 'src/components/star-grid/reportDefinition.types';
import type { PnlHierarchyTree } from 'src/components/star-grid/starGridTypes';
import { selectedMemberPositions } from 'src/components/star-grid/utils/reportParameterHierarchy';

export const useReportHierarchySelection = (
  parameter: ReportParameter,
  values: readonly string[],
  tree: PnlHierarchyTree | undefined,
  onChange: (key: string, values: readonly string[]) => void
) => {
  const [isOpen, setOpen] = useState(false);
  const initialChecked = useMemo(() => selectedMemberPositions(tree?.members ?? [], values, parameter.multiple), [tree, values, parameter.multiple]);
  const open = useCallback(() => setOpen(true), []);
  const dismiss = useCallback(() => setOpen(false), []);
  const confirm = useCallback((members: string[]) => onChange(parameter.key, members), [parameter.key, onChange]);
  return { isOpen, initialChecked, open, dismiss, confirm };
};
